// Copyright (c) 2016 Deere & Company

import './dbs-settings.scss';
import React, {PropTypes} from 'react';
import {isClaimTypStatusValid, isDBSFormValid} from '../services/form-validation';
import CheckboxListWithLabel from '../../../shared/components/checkbox-list-with-label';
import ConfirmationModal from '../../../shared/components/confirmation-modal';
import DbsSettingsModel from '@deere/cps-it.warranty-model-factory/lib/dbs-settings';
import ErrorMessage from '../../../shared/components/error-message';
import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import Modal from '../../../product/shared/state/modal';
import OptionsDropDown from '../../../shared/components/options-drop-down';
import SettingsHeader from '../../shared/components/settings-header';
import ToggleCheckboxesButton from '../../../shared/components/toggle-checkboxes-button';
import {addCollectionLabels} from '../../../shared/services/add-collection-labels';
import {create as createHashMap} from '../../../shared/services/hashmap';
import {getToggleLabel} from '../../shared/services/user-settings-helpers';
import {withRouter} from 'react-router';

let unListen;

function handleUserSettingsSave() {

    this.actions.updateUserSettings();

}

function handleClaimTypeChange(claimType, isSelected) {

    const cleanedClaimType = new KeyValuePair({
        key: claimType.key,
        value: claimType.value
    });

    this.actions.updateClaimType(cleanedClaimType, isSelected);

}

function handleToggleAll() {

    this.actions.toggleAllClaimTypes(this.userDBSSettings.claimTypes.allowedClaimTypes);

}

function handleDbsAutoSubmitChange(primaryLanguageKey) {

    this.actions.updateDbsAutoSubmit(primaryLanguageKey, this.userDBSSettings.autoSubmit.allowedOptions);

}

function handleCloseConfirmationModal() {

    this.actions.closeConfirmSaveModal(this.nextLocation);

}

function handleConfirmSaveModal() {

    isDBSFormValid(this.userDBSSettings) ?
    this.actions.confirmSaveModal(this.nextLocation) :
    this.actions.updateConfirmSaveModalVisibility(false);

}

class DbsSettings extends React.Component {

    componentWillMount() {

        this.props.actions.updateIsSaved(true);

        unListen = this.props.router.listenBefore(nextLocation => this.props.actions.handleOnPageLeave(nextLocation, this.props));

    }

    componentWillUnmount() {

        unListen();

    }

    render() {

        const isClaimTStatusValid = isClaimTypStatusValid(this.props.userDBSSettings.claimTypes.selectedClaimTypes);

        return (
            <section className='dbs-settings'>
                <span className={`status ${isClaimTStatusValid ? '' : 'error'}`}></span>
                <SettingsHeader
                    className='dbs-settings-header'
                    isSaveDisabled={this.props.isSaved || !isDBSFormValid(this.props.userDBSSettings)}
                    onSave={this.props::handleUserSettingsSave}
                    title='DBS'
                />
                <section className='dbs-settings-panel'>
                    <div className='dbs-auto-submit-dropdown'>
                        <OptionsDropDown
                            className='auto-submit'
                            isPlaceholderTranslated={false}
                            label='AUTO_SUBMIT_FROM_DEALER_BUSINESS_SYSTEM'
                            onChange={this.props::handleDbsAutoSubmitChange}
                            optionDisplayAttributes={['value']}
                            optionKey='key'
                            options={this.props.userDBSSettings.autoSubmit.allowedOptions}
                            placeholder='SELECT_AUTO_SUBMIT'
                            selectedValue={this.props.userDBSSettings.autoSubmit.key}
                        />
                    </div>
                    {this.props.userDBSSettings.autoSubmit.key === 'X' &&
                        <div className='dbs-claim-types'>
                            <CheckboxListWithLabel
                                className='claim-types-checkboxes'
                                initialState={createHashMap(this.props.userDBSSettings.claimTypes.selectedClaimTypes, 'key')}
                                isRequired={true}
                                label='CLAIM_TYPES'
                                list={addCollectionLabels(this.props.userDBSSettings.claimTypes.allowedClaimTypes, 'value')}
                                onChange={this.props::handleClaimTypeChange}
                                uid='key'
                            />
                            <ErrorMessage
                                errorMessage='ONE_ITEM_MUST_BE_SELECTED'
                                isValid={isClaimTStatusValid}
                            />
                            <ToggleCheckboxesButton
                                label={getToggleLabel(this.props.userDBSSettings.claimTypes.selectedClaimTypes)}
                                listLength={this.props.userDBSSettings.claimTypes.allowedClaimTypes.length}
                                onClick={this.props::handleToggleAll}
                            />
                        </div>
                    }
                </section>
                <ConfirmationModal
                    confirmMessage='DO_YOU_WANT_TO_SAVE_YOUR_CHANGES'
                    isOpen={this.props.confirmSaveModal.isVisible}
                    onClose={this.props::handleCloseConfirmationModal}
                    onConfirm={this.props::handleConfirmSaveModal}
                    title='SAVE_CHANGES'
                />
            </section>);

    }

}

DbsSettings.displayName = 'DbsSettings';
DbsSettings.propTypes = {
    actions: PropTypes.object.isRequired,
    confirmSaveModal: PropTypes.instanceOf(Modal).isRequired,
    isSaved: PropTypes.bool.isRequired,
    nextLocation: PropTypes.string.isRequired,
    router: PropTypes.object.isRequired,
    userDBSSettings: PropTypes.instanceOf(DbsSettingsModel).isRequired
};

export default withRouter(DbsSettings);



// WEBPACK FOOTER //
// ./src/user/dbs-settings/components/dbs-settings.js